import React from 'react';
import '../css/Footer.css';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
      </div>
      <div className="footer-info">
<p>This is a fan project by Yasin P. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
